module.exports = __webpack_public_path__ + "f36226b829a4a0dc83d774394f5baf90.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_order_2x.png
// module id = 128
// module chunks = 0 1 2 3 4